import type { ElementType } from "react";
import type { TextProps } from "./Text.types";
import { getTextStyles } from "./Text.styles";
import { cn } from "@/utils/cn";

export const Text = <C extends ElementType = "p">({
  as,
  variant = "body",
  children,
  className,
  ...props
}: TextProps<C>) => {
  const Component = as || "p";
  const styles = getTextStyles({ variant });

  return (
    <Component
      className={cn(styles.text, className)}
      {...props}
    >
      {children}
    </Component>
  );
};
